const Flickity = require('flickity');

export default () => {

    const doms = document.querySelectorAll('[data-slideshow-container]');

    function updateStyles(flickity, count, prev, next, buttons)
    {
        const current = flickity.selectedIndex;
        if (current === 0) {
            prev.classList.remove('active');
        } else {
            prev.classList.add('active');
        }

        for (const btn of buttons) {
            const index = parseInt(btn.getAttribute('data-dot')) - 1;
            if (index === current) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        }

        if (current + 1 === count) {
            next.classList.remove('active');
        } else {
            next.classList.add('active');
        }
    }

    if (doms.length) {
        for (const dom of doms) {
            const slider = dom.querySelector('[data-slideshow]');
            const count = slider.children.length;
            const buttons = dom.querySelectorAll('[data-dot]');
            const prev = dom.querySelector('[data-prev]');
            const next = dom.querySelector('[data-next]');
            const flickity = new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                prevNextButtons: false,
                pageDots: false,
            });

            updateStyles(flickity, count, prev, next, buttons);
            flickity.on('change', () => {
                updateStyles(flickity, count, prev, next, buttons);
            });

            prev.addEventListener('click', (e) => {
                flickity.previous();
            });

            next.addEventListener('click', (e) => {
                flickity.next();
            });

            for (const btn of buttons) {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    flickity.select(parseInt(btn.getAttribute('data-dot')) - 1);
                    return false;
                });
            }
        }
    }
}
